import React from 'react'

import { EuiFieldNumber, EuiFormRow, EuiHorizontalRule, EuiPanel, EuiSpacer, EuiText, EuiTitle } from '@elastic/eui'

import { FormStack } from './FormStack'
import { isBudgetValid, minQuickCampaignBudget } from './quickCampaignModels'

export interface IQuickCampaignChannelPanel {
  idPrefix: string
  title: string
  campaignName: string
  budget: number
  onBudgetChange: (budget: number) => void
  settings?: React.ReactNode
  creatives: React.ReactNode
}

export const QuickCampaignChannelPanel: React.FC<IQuickCampaignChannelPanel> = ({ idPrefix, title, campaignName, budget, onBudgetChange, settings, creatives }) => {
  const isBudgetInvalid = !isBudgetValid(budget)

  return (
    <EuiPanel hasBorder hasShadow={false} paddingSize='l'>
      <EuiTitle size='s'>
        <h2>{title}</h2>
      </EuiTitle>
      <EuiText size='s' color='subdued'>
        <p>{campaignName.length > 0 ? campaignName : 'Enter a campaign name above'}</p>
      </EuiText>
      <EuiHorizontalRule margin='l' />
      <FormStack>
        <EuiFormRow id={`${idPrefix}-budget`} label='Total Budget' isInvalid={isBudgetInvalid} error={`Budget must be at least $${minQuickCampaignBudget}`}>
          <EuiFieldNumber prepend='$' value={budget || ''} onChange={e => onBudgetChange(parseFloat(e.target.value))} isInvalid={isBudgetInvalid} />
        </EuiFormRow>
        {settings}
      </FormStack>
      <EuiHorizontalRule margin='l' />
      <EuiTitle size='xs'>
        <h3>Creatives</h3>
      </EuiTitle>
      <EuiSpacer size='m' />
      {creatives}
    </EuiPanel>
  )
}
